"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceType = void 0;
/**
 * 设备类型
 */
var DeviceType;
(function (DeviceType) {
    DeviceType[DeviceType["WEB"] = 0] = "WEB";
    DeviceType[DeviceType["H5"] = 1] = "H5";
    DeviceType[DeviceType["ANRDOID"] = 2] = "ANRDOID";
    DeviceType[DeviceType["IOS"] = 3] = "IOS";
    DeviceType[DeviceType["WXMP"] = 4] = "WXMP";
    DeviceType[DeviceType["DESK"] = 5] = "DESK";
})(DeviceType = exports.DeviceType || (exports.DeviceType = {}));
